import { formatTitle } from '@/services/utils';
import { normalizeName } from '@/utils/strings';

export const DEFAULT_TABLE_META = { page: 1, perPage: 5, total: 0, totalPages: 1 };
export const SECTOR_CATALOG_LIMIT = 100;
export const DEFAULT_SECTOR_FILTER = 'all';
export const WITHOUT_SECTOR_FILTER = 'without';
export const NO_SECTOR_LABEL = '— Definir setor';

export const toSectorOption = (sector) => ({ value: sector.id, label: formatTitle(sector.name) });

export const buildSectorFilterParams = (filter) => {
	if (filter === WITHOUT_SECTOR_FILTER) return { withoutSector: true };
	if (filter && filter !== DEFAULT_SECTOR_FILTER) return { sectorId: filter };
	return {};
};

export const buildSectorFilterOptions = (sectors = []) => [
	{ value: DEFAULT_SECTOR_FILTER, label: 'Todos' },
	{ value: WITHOUT_SECTOR_FILTER, label: 'Sem setor' },
	...sectors.map((sector) => ({
		value: sector.id,
		label: sector.status === 'active' ? formatTitle(sector.name) : `${formatTitle(sector.name)} (inativo)`,
	})),
];

export const buildUserSectorOptions = (activeOptions = [], user = {}) => {
	if (!user?.sectorId || activeOptions.some((option) => option.value === user.sectorId)) return activeOptions;
	return [{ value: user.sectorId, label: `${formatTitle(user.sectorName)} (inativo)` }, ...activeOptions];
};

export const findActiveSectorByName = (sectors = [], name) =>
	sectors.find((sector) => sector.status === 'active' && normalizeName(sector.name) === normalizeName(name));
